/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Login_With_PasskeyInputs */

const nl_auth_passkey_login_with_passkey = /** @type {(inputs: Auth_Passkey_Login_With_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen met passkey`)
};

/**

* @param {Auth_Passkey_Login_With_PasskeyInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_passkey_login_with_passkey = /** @type {((inputs?: Auth_Passkey_Login_With_PasskeyInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Login_With_PasskeyInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_passkey_login_with_passkey(inputs)
});
export { auth_passkey_login_with_passkey as "auth.passkey.login_with_passkey" }